import { Controller } from '@hotwired/stimulus'
import TomSelect from 'tom-select'

// Front-only investor picker: a searchable select showing each investor with its KYC
// status badge. The badge markup is the server-rendered StatusBadgeComponent, passed
// per option through data-badge, so we reuse the shared badge presentation instead of
// rebuilding it in JS. Kept separate from the generic tom_select_controller, which is
// also used by the (non-Stimulus) admin and must stay presentation-agnostic.
function renderOption(data, escape) {
  const label = `<span>${escape(data.text)}</span>`
  if (!data.badge) return `<div>${label}</div>`

  return `<div class="d-flex align-items-center justify-content-between gap-2">${label}${data.badge}</div>`
}

export default class extends Controller {
  connect() {
    if (this.element.tomselect) return

    new TomSelect(this.element, { render: { option: renderOption, item: renderOption } })
  }

  disconnect() {
    this.element.tomselect?.destroy()
  }
}
